import React from 'react';
import type { ChangeEvent, KeyboardEventHandler } from 'react';
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { CircleCloseIcon, SearchIcon } from '../../../icons';

interface SearchInputProps {
    searchTerm: string;
    placeholder?: string;
    showSuggestions?: boolean;
    onSearch: (e: ChangeEvent<HTMLInputElement>) => void;
    onKeyDown: KeyboardEventHandler<HTMLInputElement>;
    onSubmitSearch: () => void;
    onClearSearch: () => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
    searchTerm,
    placeholder,
    showSuggestions = true,
    onSearch,
    onKeyDown,
    onSubmitSearch,
    onClearSearch,
}) => {
    const intl = useIntl();

    return (
        <InputGroup>
            <Input
                variant="slt-search"
                data-testid="header.menu.search.input"
                placeholder={
                    placeholder ??
                    intl.formatMessage({
                        id: 'header.menu.search.placeholder',
                        defaultMessage: 'What are you looking for?',
                    })
                }
                onKeyDown={onKeyDown}
                onChange={onSearch}
                value={searchTerm}
            />

            <InputRightElement height="100%" width={6} marginX={4}>
                {searchTerm && showSuggestions ? (
                    <button
                        type="button"
                        className="inline-flex items-center justify-center"
                        data-testid="header.menu.search.clear.button"
                        onClick={onClearSearch}
                    >
                        <CircleCloseIcon data-testid="header.menu.clear.search.icon" />
                    </button>
                ) : (
                    <button
                        type="button"
                        className="inline-flex items-center justify-center"
                        data-testid="header.menu.search.button"
                        onClick={onSubmitSearch}
                    >
                        <SearchIcon data-testid="header.menu.search.icon" width={4} height={4} />
                    </button>
                )}
            </InputRightElement>
        </InputGroup>
    );
};
